import { UploadDocumentsModal } from 'features/Dashboard/components/modal/upload-documents';

export const DashbordTopBar = ({
  setShowModal,
  showModal,
  titleDocuments,
  refetch,
}: any) => {
  return (
    <>
      {/* <ContentTopBar title={t('newclient.heading')} /> */}
      {showModal && (
        <UploadDocumentsModal
          onClose={() => setShowModal(false)}
          titleDocuments={titleDocuments}
          refetch={refetch}
        />
      )}
    </>
  );
};
